module.exports = __webpack_public_path__ + "media/images/mobile/home/type3-5cc3aeaa96ab9800a616d8131076144b.png";